export const GET_CONTENT_TYPES_REQUEST = 'GET_CONTENT_TYPES_REQUEST';
export const GET_CONTENT_TYPES_SUCCESS = 'GET_CONTENT_TYPES_SUCCESS';
export const GET_CONTENT_TYPES_FAILURE = 'GET_CONTENT_TYPES_FAILURE';
